<div class="sidenav" fxLayout="column" style="">

    <!-- Layout: Alpha -->
    <div class="header" fxLayout="row" fxLayoutAlign="start center" *ngIf="layout === 'alpha'">

        <img class="logo" alt="logo" src="assets/img/jasmine.png">
        <span fxFlex></span>

        <div class="actions" fxLayout="row" fxLayoutAlign="start center">
            <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="collapsed">
                <mat-icon>radio_button_unchecked</mat-icon>
            </button>
            <button class="toggle" type="button" mat-icon-button (click)="toggleSidenavCollapse()" *ngIf="!collapsed">
                <mat-icon>radio_button_checked</mat-icon>
            </button>
        </div>
    </div>
    <!-- /Layout: Alpha -->

    <vr-scrollbar class="menu" fxFlex>

        <div class="sa_filters_menu">
            <a class="mymenu active" href="#" (click)="changeMenu($event,'menu')"><i class="fa fa-home">&nbsp;</i>Menu</a>
            <a class="mymenu" href="#"  (click)="changeMenu($event,'filter')"><i class="fa fa-home">&nbsp;</i>Filter</a>

        </div>

        <div class="pull-left col-12">
            <div class="pull-left col-12 sa_menu_area mymenu1 menu activme">

                <div class="sidenav-item-holder" *ngFor="let item of sidenavItems$ | async">
                    <vr-sidenav-item class="sidenav-item-container" [item]="item"
                                     [currentlyOpen]="currentlyOpen$ | async"></vr-sidenav-item>
                </div>

            </div>
            <div class="pull-left col-12 sa_filter_area menu mymenu2 ">
                <!-- <a href="javascript:void(0);" class=" reset" (click)="reset()">Reset</a> -->
                <form #f="ngForm" class="sa_forms_filter drfom">

                    <!-- <mat-input-container class="pull-left col-12">
                         <input matInput placeholder="No. of Plants" type="text" formControlName="plants">
                     </mat-input-container>-->
                    <mat-form-field>
                        <mat-select placeholder="Region"   class="form-control" [(ngModel)]="regionid" name="region"
                                    (selectionChange)="getSitesByRegion()" multiple>
                            <mat-option ngValue = "null" *ngFor="let region of regions" value="{{region.id}}">
                                {{region.name | titlecase}}</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Site"   class="form-control" [(ngModel)]="siteid" name="site" multiple >
                            <mat-option ngValue = "null" *ngFor="let site of sites" value="{{site.id}}">
                                {{site.name | titlecase}}</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Site Type"  class="form-control selectpicker" [(ngModel)]="partyid" name="partyid" multiple>
                            <mat-option ngValue = "null"  value= "1"> Client</mat-option>
                            <mat-option ngValue = "null"  value= "2"> Vendor</mat-option>
                            <mat-option ngValue = "null"  value= "3"> Self</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Profile"   class="form-control" [(ngModel)]="profileid" name="profileid" multiple >
                            <mat-option ngValue = "null" *ngFor="let profiles of profile" value="{{profiles.id}}">
                                {{profiles.name | titlecase}}</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Cold Store Type"   class="form-control" [(ngModel)]="profileTypeId" name="profileType" multiple >
                            <mat-option ngValue = "null" *ngFor="let profiles of profileType" value="{{profiles.id}}">
                                {{profiles.name | titlecase}}</mat-option>

                        </mat-select>
                    </mat-form-field>

                    <mat-form-field>
                        <mat-select placeholder="Food Type" class="form-control selectpicker" [(ngModel)]="commodityid" name="commodity" multiple>
                            <mat-option ngValue = "null" *ngFor="let t of commodityDD" value={{t.id}}> {{t.name | titlecase}}</mat-option>

                        </mat-select>
                    </mat-form-field>


                    <mat-form-field>
                        <mat-select placeholder="Connectivity"  class="form-control selectpicker" [(ngModel)]="connectivityid" name="partyid">
                            <mat-option ngValue = "null"  value = "true"> Online</mat-option>
                            <mat-option ngValue = "null"  value = "false"> Offline</mat-option>

                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Esclation Level"  class="form-control selectpicker" [(ngModel)]="levelid" name="levelid"
                                     multiple>
                            <mat-option ngValue = "null"  value= "1"> Level 1</mat-option>
                            <mat-option ngValue = "null"  value= "2"> Level 2</mat-option>
                            <mat-option ngValue = "null"  value= "3"> Level 3</mat-option>
                            <mat-option ngValue = "null"  value= "4"> Level 4</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <mat-form-field>
                        <mat-select placeholder="Status"  class="form-control selectpicker" [(ngModel)]="csStatusId" name="csStatusId"
                                     multiple>
                            <mat-option ngValue = "null"  value= "1">Normal</mat-option>
                            <mat-option ngValue = "null"  value= "2">Under Maintenance</mat-option>
                            <mat-option ngValue = "null"  value= "3">Audit</mat-option>
                            <mat-option ngValue = "null"  value= "4">Power Off</mat-option>
                        </mat-select>
                    </mat-form-field>
                    <div class="buttonWrap">
                        <button type="button" class="button" (click)="reset()">Reset</button>
                        <button type="button" class="button solidButton" (click)="getColdStoreBasedOnFilter()">Submit</button>
                    </div>

                </form>
            </div>
        </div>


    </vr-scrollbar>

</div>
